import React, { useEffect } from 'react'
import { withRouter } from 'react-router'
import { useDispatch } from 'react-redux'
import { setCookie } from '../../utils/general'
import Footer from '../../components/Footer'
import ReviewCard from '../../components/ReviewCard/ReviewCard'
import HomeHeader from '../../components/HomePageHeader'
import ExamplesGrid from '../../Examples/components/ExamplesGrid/ExamplesGrid'
import examples from '../../Landing/UseCases/UseCases.json'
import { toggleSignUpModal } from '../../Manage/actions'
import CTAButton from '../../components/CTAButton/CTAButton'
import FAQ from '../../Landing/FAQ/FAQ'
import { LogoShowcase } from '../../Landing/Home/Home'
import HeroVideo from './HeroVideo'

import styles from './AdLanding.module.css'

const TEXT_CONTENT = {
  s: {
    title: 'The Smarter Way To Manage Long Sales Cycles',
    subtitle: 'Keep prospects engaged through a long buying processes by knowing exactly when to follow up.',
    teaser: 'Get notified when your leads are ready to buy.',
    img: '/assets/img/sales-illus.png'
  },
  vibe: {
    title: (
      <>
        Live in <span className="gradient-text">Under 20 Seconds</span>
      </>
    ),
    subtitle: 'Skip Git, build configs and deployment tutorials. Just drag & drop your HTML to publish it.',
    teaser: "It's really that simple.",
    cta: 'Try it free'
  },
  default: {
    title: (
      <>
        The <span className="gradient-text">Simplest</span> Way To Share Your Work Online
      </>
    ),
    subtitle: 'Drag & drop 80+ file types to get a shareable link in seconds.',
    teaser: "It's really that simple.",
    cta: 'Try it free'
  }
}

const ExamplesSection = ({ history, examples }) => {
  return (
    <div className="container mt-5 mb-5 text-center">
      <div className="d-flex flex-column align-items-center mb-lg-5">
        <h1 className="gradient-text w-75 font-weight-900 font-47">A tiiny tool with endless possibilities</h1>
        <p className="grey text-start font-20 p-4">
          You can use tiiny to share many different types of documents, files or projects online.
        </p>
      </div>
      <ExamplesGrid examples={examples} history={history} align="center" />
    </div>
  )
}

const AboveFold = ({ content }) => {
  const dispatch = useDispatch()

  return (
    <div className="container-lg mt-lg-5 mb-5 d-lg-flex d-column align-items-center p-4">
      <div className={styles.titleContainer}>
        <h1 className={`${styles.h1} black`}>{content.title}</h1>
        <div className="d-lg-none d-block mt-3 mb-3">
          <HeroVideo src={content.video || '/assets/img/teaser.mp4'} height={275} />
        </div>
        <p className="text-start font-20 mt-4">{content.subtitle}</p>
        <p className="text-start font-20 mt-5">
          <b>{content.teaser}</b>
        </p>
        <CTAButton
          className="mt-4"
          label={content.cta}
          onClick={() => dispatch(toggleSignUpModal(true))}
          variant="primary-gradient-round"
          size="large"
        />
      </div>
      <div className="round-20 d-lg-block d-none flex-1">
        <HeroVideo src={content.video || '/assets/img/teaser.mp4'} height={400} />
      </div>
    </div>
  )
}

const ReferralLanding = ({ history, location }) => {
  const urlParams = new URLSearchParams(location.search)
  const contentType = urlParams.get('t') || 'default'

  const content = TEXT_CONTENT[contentType] || TEXT_CONTENT.default

  useEffect(() => {
    if (location.pathname === '/rl') {
      setCookie('signup_origin', 'rl', 30)
    }
  }, [location.pathname])

  return (
    <div className="body-bg full-height">
      <HomeHeader simplified />
      <AboveFold content={content} />
      <LogoShowcase className="ms-3 me-3 mb-3" />
      <ReviewCard />
      <ExamplesSection history={history} examples={examples} content={content} />
      <FAQ showCTA={false} />
      <Footer simplified />
    </div>
  )
}

export default withRouter(ReferralLanding)
